<template>
  <el-row>
    <el-form :model="distributionBusinessGroupForm"
             ref="distributionBusinessGroupRef"
             editAction="/weChartCpCustom/editGroupRecord.action"
             label-width="150px"
             style="width:50%"
             v-form>

        <el-form-item label="群名称：">
            <el-select v-model="distributionBusinessGroupForm.businessGroupId" placeholder="请选择车商群" :clearable="true" :filterable="true">
                <el-option
                        v-for="item in businessGroups"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'
export default {
  name: 'distributionBusinessGroup',
  extends: BasicPager,
  data: function () {
    return {
      rules: {},
      distributionBusinessGroupForm: {
        id: null,
        businessGroupId: null
      },
      businessGroups: []

    }
  },
  created () {
    let _this = this
    let params = {}
    let listener = {
      success: function (dataInfo) {
        _this.businessGroups = dataInfo.datas
      }

    }

    BasicModel.get(_this, '/weChartCpCustom/findChooseGroupList.action', params, listener)

    this.distributionBusinessGroupForm.id = this.$route.query.id
    this.distributionBusinessGroupForm.businessGroupId = this.$route.query.businessGroupId
  },
  methods: {
    onFilterParams: function (params) {

    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
